export const BaseURL = 'https://sophians2020.microcms.io/api/v1';
export const ApiKey = '2f3bd24c-437a-4509-85ba-0df93250ccc4';
export const isMock = () => {
    return (window as any)?.NaviScripts?.isBuild;
};